const couponQueryHandler = () => {
  const url = new URL(window.location.href);
  const param = url.searchParams.get('coupon') || '';
  return param.split(',').filter(Boolean);
};

export default couponQueryHandler;
